import { useEffect } from 'react';

const useClickOutside = (showOptions: any, toggleOptions: any, ref: any) => {
  useEffect(
    function clickOutside() {
      // Use the effect to close the dropdown if admin user clicks outside.
      const handleClickOutside = (e: any) => {
        if (ref.current?.contains(e.target)) {
          return;
        }
        if (showOptions) {
          toggleOptions();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    },
    [showOptions, toggleOptions, ref],
  );
};

export default useClickOutside;
